export default __webpack_public_path__ + "static/media/Logo_US_Intro1.fb858128.png";